import { render, staticRenderFns } from "./Infographics.vue?vue&type=template&id=c40678f4"
import script from "./Infographics.vue?vue&type=script&lang=js"
export * from "./Infographics.vue?vue&type=script&lang=js"
import style0 from "./Infographics.vue?vue&type=style&index=0&id=c40678f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports